import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// local dependencies
import { memberDetailsPayBalanceWidget as MemberDetailsPayBalanceWidgetView } from 'ui/views/widgets/memberDetailsPayBalanceWidget';
import { MemberDetailsPayBalanceWidgetService } from 'services/memberDetailsPayBalanceWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsPayBalanceWidget } from 'ui/containers/MemberDetailsPayBalanceWidget';
 *
 * // render
 * <MemberDetailsPayBalanceWidget propName='propValue'/>
 */
class _MemberDetailsPayBalanceWidget extends React.Component {
	
	/**
	 * @param {object} props - props
	 */
	constructor( props ) {
		super( props );

		this.handleActionClick = this.handleActionClick.bind( this );

		// component state
		this.state = {
			isFetching: true,
			networkStatus: undefined,
			componentData: undefined,
		};

		// create service instance
		this.memberDetailsPayBalanceWidgetService = new MemberDetailsPayBalanceWidgetService();

		// start component data fetch
		this.fetchComponentData();
	}

	// /*********************************************/

	/**
	 * @desc Fetch component response.
	 */
	async fetchComponentData() {
		log.debug( 'MemberDetailsPayBalanceWidget.fetchComponentData()' );

		try {
			const {
				status,
				data,
			} = await this.memberDetailsPayBalanceWidgetService.fetchComponentData( {
				url: this.props.widget.url,
				data: this.props.requestPayload,
			} );

			// check if response status was success
			if ( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
				this.setState( {
					isFetching: false,
					networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
				} );
			} else {

				this.setState( {
					isFetching: false,
					networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
					componentData: data,
					overlayTitle: getLabel( data.title )
				} );

			}
		} catch ( e ) {
			this.setState( {
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
			} );
		}
	}

	/**
	 * @desc Handle action click
	 */
	handleActionClick() {
		log.debug( 'MemberDetailsPayBalanceWidget.handleActionClick()' );

		// check if payment is allowed
		if( ! get( this.state, 'componentData.balanceAndSavings.allowPayment', true ) ) {
			return; // no-op
		}

        const memberId = get( this.props.location, 'state.memberId', undefined );

		// open pay balance page
        this.props.history.push( {
			pathname: DASHBOARD_SUB_ROUTES.PAY_BALANCE,
			state: { memberId: memberId  }
		} );
	}

	// async displayPayBalanceSteps( { url } ) {
	// 	log.debug( 'MemberDetailsPayBalancesWidget.displayPayBalanceSteps()' );

	// 	// cancel ongoing request
	// 	this.memberDetailsPayBalanceWidgetService.cancel();

	// 	// show page level preloader
	// 	pageLevelPreloader.show();

	// 	// get status and service data
	// 	const {
	// 		status,
	// 		data,
	// 	} = await this.memberDetailsPayBalanceWidgetService.fetchPayBalanceStepsData(
	// 		{
	// 			url: url,
	// 			data: this.props.requestPayload,
	// 		}
	// 	);

	// 	// show page level preloader
	// 	pageLevelPreloader.hide();

	// 	if ( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
	// 		overlay.open( {
	// 			settings: {
	// 				modalType: OVERLAY_VIEWS.PAY_BALANCE_STEPS,
	// 				showCloseButton: false,
	// 				ignoreOutsideClick: true,
	// 			},
	// 			config: {},
	// 			data: {
	// 				...data,
	// 				requestPayload: {
	// 					context: { memberId: this.props.memberId }
	// 				},
    //                 overlayTitle: this.state.overlayTitle,
	// 				onCancelClick: () => {
	// 					overlay.close();
	// 				},
	// 			},
	// 		} );
	// 	} else {
	// 		errorOverlay.open(); // show error
	// 	}
	// }

	/*********************************************/

	/**
	 * @desc When component unmounts, cleanup resouces.
	 */
	componentWillUnmount() {
		this.memberDetailsPayBalanceWidgetService.cancel(); // cancel ongoing requests
	}

	/**
	 * @desc Render a React view component
	 */
	render() {
		return (
			<MemberDetailsPayBalanceWidgetView
				isFetching={ this.state.isFetching }
				{ ...get( this.state, 'componentData', {} ) }
				networkStatus={ this.state.networkStatus }
				onActionClick={ this.handleActionClick }
			/>
		);
	}
}

// set display name
_MemberDetailsPayBalanceWidget.displayName = '_MemberDetailsPayBalanceWidget';

// set default props
_MemberDetailsPayBalanceWidget.defaultProps = {};

// prop types
_MemberDetailsPayBalanceWidget.propTypes = {};

/*********************************************/

// wrap with app context
export const MemberDetailsPayBalanceWidget = withRouter( _MemberDetailsPayBalanceWidget );
